import { render } from "./PairToggle.vue?vue&type=template&id=2ea32e83&ts=true"
import script from "./PairToggle.vue?vue&type=script&lang=ts"
export * from "./PairToggle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__